import React from "react";
import lodashDebounce from "lodash.debounce";
/**
 * useDebounce
 * Debounce function used by OpenJSCAD component to debounce
 * changes in props.jscadScript passed into the OpenJSCADProcessor component
 * @param obj - The state being stored in a debounced state
 * @param wait - optional - the debounce timeout
 */
export function useDebounce(obj = null, wait = 1000) {
    const [state, setState] = React.useState(obj);
    const setDebouncedState = (_val) => {
        debounce(_val);
    };
    const debounce = React.useCallback(lodashDebounce((_prop) => {
        setState(_prop);
    }, wait), []);
    return [state, setDebouncedState];
}
//# sourceMappingURL=useDebounce.js.map